// extracted by mini-css-extract-plugin
module.exports = {"blogPostWrapper":"BlogPost_blogPostWrapper__91nQc","blogPost":"BlogPost_blogPost__AMdom","excerpt":"BlogPost_excerpt__dfxbp"};